import React from 'react';
import HeaderSC from './header.styled';
import { ReactComponent as HilbiLogo } from '../../../../assets/svg/hilbi-logo-shape.svg';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@components/ui';
interface IHeaderProps {
  step?: number;
  textId: string;
  className?: string;
}

const Header: React.FC<IHeaderProps> = ({ step, textId, className }) => {
  return (
    <HeaderSC step={step} className={className}>
      <HilbiLogo className="header-logo" />
      <Typography display="h1" variant="default">
        <FormattedMessage id={textId} />
      </Typography>
    </HeaderSC>
  );
};

export default Header;
